/*
    ./app/app.js
*/
import React from 'react';

import { Helmet } from "react-helmet";

import { BrowserRouter as Router, Route, IndexRoute, Link, IndexLink, browserHistory, Switch, HashRouter } from "react-router-dom";
import { DelayLink, ListItem, GAnalytics } from './components/';

import $ from 'jquery';

import { AnimatedSwitch, AnimatedRoute } from 'react-router-transition';

import {
	Home,

	Mensagens,

	QuemSomosPerfil,
	QuemSomosVisao,

	Associados,

	GovernancaAssembleiaGeral,
	GovernancaDiretoria,
	GovernancaConselhoFiscal,
	GovernancaConselhoEtica,
	GovernancaComiteExecutivo,
	GovernancaNossosForuns,

	Pessoas,
	Perfil,
	QualidadeVida,
	Engajamento,

	EstrategiaPlanoAcao,
	EstrategiaCurtoPrazo,
	EstrategiaLongoPrazo,
	EstrategiaRelacionamentos,

	NossoAnoIniciativas,
	NossoAnoEventos,
	NossoAnoInvestimentos,

	SobreRelatorio,
	SumarioGri,
	Creditos,

	NotFound

} from './views';

import { Dispatcher, Events, Actions } from './flux';

import { TimelineMax, TweenMax } from 'gsap';

import {
	images,
	texts,
	sequences,
	menus
} from './settings/';

import {
	ShapeOverlays
} from './utils/';

import './app.scss';

export default class App extends React.Component {
	constructor () {
		super();

        window.jQuery = $;
        window.$ = $;
        this.$ = $;
        global.jQuery = $;

		this.images = images;
		this.sequences = sequences;
		this.menus = menus;

		this.state = {
            width: window.innerWidth,
			mobileMenu: '',
			backButton: '',
			logoIntern: '',
			menuButton: '',
			menuBody: false,
			menuVectorColor: '#b0c91f',
			showFooter: false,

			menuPrevText: 'Home',
			menuPrevLink: '/',
			menuPrevClass: '',

			menuNextText: '01 Mensagens',
			menuNextLink: '/mensagens',
			menuNextClass: ''
		};

		this.elmOverlay;
		this.overlay;

		this.globalDelay = 1000;

	    this.scrollTop = this.scrollTop.bind(this);
		this.animateTransition = this.animateTransition.bind(this);
		this.animateOverlay = this.animateOverlay.bind(this);
		this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
		this.loadbar = this.loadbar.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.changeMenuVectorColor = this.changeMenuVectorColor.bind(this);
		this.dShowFooter = this.dShowFooter.bind(this);
		this.dHideFooter = this.dHideFooter.bind(this);

        this.bodyRef = React.createRef();

        document.addEventListener('DOMContentLoaded', this.loadbar, false);
	}

	scrollTop() {
		window.scrollTo({ top: this.bodyRef.current.offsetTop });
	}

	toggleMobileMenu() {
		this.setState({ mobileMenu: 'shown' });

		if (this.state.mobileMenu == 'shown') {
			this.setState({ mobileMenu: '' });
		} else {
			this.setState({ mobileMenu: 'shown' });
		}
	}

	changeMenuVectorColor(color) {
		this.setState({ menuVectorColor : color });
	}

	loadbar() {
		var _this = this;
		function id(v){ return document.getElementById(v); }

		var ovrl = id("loading"),
		    prog = id("progress"),
		    img = document.images,
		    c = 0,
		    tot = img.length;

		if (tot == 0) return doneLoading();

		function imgLoaded() {
			c += 1;
			var perc = ((100/tot*c) << 0) +"%";
			prog.style.width = perc;
			if(c===tot) return doneLoading();
		}

		function doneLoading() {
			_this.$('#loading').fadeOut('slow');
		}

		for(var i=0; i<tot; i++) {
			var tImg     = new Image();
			tImg.onload  = imgLoaded;
			tImg.onerror = imgLoaded;
			tImg.src     = img[i].src;
		}
	}

	mapStyles(styles) {
	  return {
	    opacity: styles.opacity,
	    transform: `scale(${styles.scale})`,
	  };
	}

	dEmitPage(name) {
		let menuIndex = this.menus.map(function (obj) { return obj.name; }).indexOf(name);
		let prev = ((menuIndex - 1) >= 0) ? this.menus[menuIndex-1] : { name: '', url: '' };
		let next = ((menuIndex + 1) < this.menus.length) ? this.menus[menuIndex+1] : this.menus[0];

		// console.log('page', prev);

		this.setState({
			menuPrevText: prev.name,
			menuPrevLink: prev.url,
			menuPrevClass: prev.class,
			menuNextText: next.name,
			menuNextLink: next.url,
			menuNextClass: next.class
		});
	}

	dShowFooter() {
		this.setState({ showFooter: true });
	}

	dHideFooter() {
		this.setState({ showFooter: false });
	}

	dAnimateTransition() {
        this.animateTransition();
    }

    dChangeMenuTointern() {
		this.setState({ menuButton: 'menu_handle--intern' });
    }

    dChangeMenuToHome() {
		this.setState({ menuButton: '' });
    }

    changeMenu(delay = false) {
    	this.animateTransition();

    	if (this.state.menuBody) {
    		this.dChangeLogoToHome();

			setTimeout(function() {
    			this.dHideMenu();
			}.bind(this), (delay) ? 500 : 0);
    	} else {
    		// this.dShowMenu();
    		// this.dChangeMenuToHome();

			setTimeout(function() {
    			this.dShowMenu();
			}.bind(this), (delay) ? 500 : 0);

			setTimeout(function() {
    			this.dChangeLogoTointern();
			}.bind(this), 300);
    	}
    }

    changeMenuTransition() {
    	this.changeMenu(true);
    	this.animateTransition();
    }

    dShowMenu() {
    	this.setState({ menuBody: true });
    }

    dHideMenu() {
    	this.setState({ menuBody: false });
    }

    dChangeLogoTointern() {
        this.setState({ logoIntern: 'intern_logo--shown' });
    }

    dChangeLogoToHome() {
        this.setState({ logoIntern: '' });
    }

    dBackButon() {
    	console.log('back active');
		this.setState({ backButton: 'shown' });
    }

    dBackButonOff() {
    	console.log('back inactive');
		this.setState({ backButton: '' });
    }

    dCloseService() {
    	Actions.closeServiceRequest();
    }

    goHome() {
    	if (this.state.menuBody) {
    		this.changeMenuTransition();
    	}
    	Actions.globalTransition();
    }

	handleScroll() {
		if (window.scrollY > 170) {
			Actions.menuHome();
		} else {
			Actions.menuIntern();
		}
	}

	componentWillMount() {
        // Dispatcher
        Dispatcher.on(Events.EMIT_PAGE, this.dEmitPage.bind(this) );
        Dispatcher.on(Events.SHOW_FOOTER, this.dShowFooter.bind(this) );
        Dispatcher.on(Events.HIDE_FOOTER, this.dHideFooter.bind(this) );
        Dispatcher.on(Events.MENU_INTERN, this.dChangeMenuTointern.bind(this) );
        Dispatcher.on(Events.MENU_HOME, this.dChangeMenuToHome.bind(this) );
        Dispatcher.on(Events.LOGO_INTERN, this.dChangeLogoTointern.bind(this) );
        Dispatcher.on(Events.LOGO_HOME, this.dChangeLogoToHome.bind(this) );
        Dispatcher.on(Events.GLOBAL_TRANSITION, this.dAnimateTransition.bind(this) );
        Dispatcher.on(Events.OPEN_SERVICE, this.dBackButon.bind(this) );
        Dispatcher.on(Events.CLOSE_SERVICE, this.dBackButonOff.bind(this) );
    }

	componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll);

		this.elmOverlay = document.querySelector('.shape-overlays');
		this.overlay = new ShapeOverlays(this.elmOverlay);
    }

    componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll);

        // Dispatcher

        Dispatcher.removeListener(Events.EMIT_PAGE, this.dEmitPage );
        Dispatcher.removeListener(Events.SHOW_FOOTER, this.dShowFooter );
        Dispatcher.removeListener(Events.HIDE_FOOTER, this.dHideFooter );
        Dispatcher.removeListener(Events.MENU_INTERN, this.dChangeMenuTointern );
        Dispatcher.removeListener(Events.MENU_HOME, this.dChangeMenuToHome );
        Dispatcher.removeListener(Events.LOGO_INTERN, this.dChangeLogoTointern );
        Dispatcher.removeListener(Events.LOGO_HOME, this.dChangeLogoToHome );
        Dispatcher.removeListener(Events.GLOBAL_TRANSITION, this.dAnimateTransition );
        Dispatcher.removeListener(Events.OPEN_SERVICE, this.dBackButon );
        Dispatcher.removeListener(Events.CLOSE_SERVICE, this.dBackButonOff );
    }

	animateTransition() {
        // this.toggleMobileMenu();
        this.animateOverlay();

        setTimeout(function() {
        	this.scrollTop();
        }.bind(this), this.globalDelay);
	}

	animateOverlay() {
	    if (!this.overlay.isAnimating) {
	    	this.overlay.toggle();

			setTimeout(function() {
				this.overlay.toggle();
			}.bind(this), this.globalDelay);
	    }
	}

  	render() {

  		var itemClasslist = [
  			'column',
  			'column--half',
  			'column--menu',
  			this.state.mobileMenu
  		];

  		var backButtonClassList = [
  			'back_button_mobile',
  			this.state.backButton
  		];

  		var logoClassList = [
  			'intern_logo',
  			this.state.logoIntern
  		];

  		var menuClassList = [
  			'menu_handle',
  			this.state.menuButton
  		];

  		var menuBodyClassList = [
  			'menu_body',
  			(this.state.menuBody) ? 'menu_body--shown' : ''
  		];

  		var footerClassItem = [
  			'footer_navigation',
  			(this.state.showFooter) ? 'footer_navigation--shown' : ''
  		];

  		var footerNextClassItem = [
  			"side",
  			"side--right",
  			this.state.menuNextClass
  		];

  		var footerPrevClassItem = [
  			"side",
  			"side--left",
  			this.state.menuPrevClass
  		];

		return (

			<HashRouter history={ browserHistory }>
				<div className="app" ref={ this.bodyRef }>
					<Helmet>
		                <title>{ texts.title }</title>
		                <meta name="title" content={ texts.title } />
		                <meta name="description" content={ texts.description } />
		            </Helmet>


					<svg className="shape-overlays" viewBox="0 0 100 100" preserveAspectRatio="none">
						<path className="shape-overlays__path"></path>
						<path className="shape-overlays__path"></path>
						<path className="shape-overlays__path"></path>
					</svg>

					<div className="transition_layer">
						<div className="layer1" ref="layer1"></div>
						<div className="layer2" ref="layer2"></div>
						<div className="layer3" ref="layer3"></div>
					</div>

					<div className={ logoClassList.join(' ') } onClick={ this.goHome.bind(this) }>
						<DelayLink to="/" delay={1000}>
            				<img src={ this.images.logo } />
            			</DelayLink>
					</div>

					<div className={ menuClassList.join(' ') } onClick={ this.changeMenu.bind(this, true) }>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443 429.05"><path className="st0" d="M221.49 14.52c-110.28 0-199.99 89.72-199.99 200s89.72 200 199.99 200c110.28 0 200.01-89.72 200.01-200s-89.72-200-200.01-200zm0 373.77c-95.81 0-173.76-77.95-173.76-173.77 0-95.82 77.95-173.77 173.76-173.77 95.82 0 173.77 77.95 173.77 173.77.01 95.82-77.95 173.77-173.77 173.77z"/><path className="st0" d="M301.87 227.64H142.12c-7.24 0-13.11-5.87-13.11-13.11 0-7.24 5.87-13.11 13.11-13.11h159.75c7.24 0 13.11 5.87 13.11 13.11 0 7.24-5.87 13.11-13.11 13.11zM301.87 307.12H142.12c-7.24 0-13.11-5.87-13.11-13.11 0-7.24 5.87-13.11 13.11-13.11h159.75c7.24 0 13.11 5.87 13.11 13.11 0 7.24-5.87 13.11-13.11 13.11zM301.87 148.16H142.12c-7.24 0-13.11-5.87-13.11-13.11 0-7.24 5.87-13.11 13.11-13.11h159.75c7.24 0 13.11 5.87 13.11 13.11 0 7.24-5.87 13.11-13.11 13.11z"/></svg>
					</div>

					<div className={ menuBodyClassList.join(' ') }>
						<div className="color_vectors">
							<svg xmlns="http://www.w3.org/2000/svg" width="2004.256" height="1313.067" viewBox="0 0 2004.256 1313.067">
							  <g id="Agrupar_88" data-name="Agrupar 88" transform="translate(91.654 15.523)">
							    <g id="Agrupar_74" data-name="Agrupar 74" transform="translate(-51.466 1111.147)" opacity="0.5">
							      <path id="Caminho_603" data-name="Caminho 603" d="M270.254,373.111C265.4,380.673,111.356,610,111.356,610h30.408s82.605-3.613,126.019-59.4c4.851-7.562,158.894-236.894,158.894-236.894H396.268S312.18,309.524,270.254,373.111Z" transform="translate(704.395 -424.107)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							      <path id="Caminho_604" data-name="Caminho 604" d="M218.256,353.654c-3.265,5.087-106.9,159.373-106.9,159.373h20.458s55.573-2.43,84.78-39.963c3.264-5.087,106.9-159.373,106.9-159.373H303.034S246.463,310.875,218.256,353.654Z" transform="translate(933.639 -475.414)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							    </g>
							    <g id="Agrupar_75" data-name="Agrupar 75" transform="translate(-988.466 820.147)" opacity="0.5">
							      <path id="Caminho_603-2" data-name="Caminho 603" d="M270.254,373.111C265.4,380.673,111.356,610,111.356,610h30.408s82.605-3.613,126.019-59.4c4.851-7.562,158.894-236.894,158.894-236.894H396.268S312.18,309.524,270.254,373.111Z" transform="translate(786.395 -480.107)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							      <path id="Caminho_604-2" data-name="Caminho 604" d="M218.256,353.654c-3.265,5.087-106.9,159.373-106.9,159.373h20.458s55.573-2.43,84.78-39.963c3.264-5.087,106.9-159.373,106.9-159.373H303.034S246.463,310.875,218.256,353.654Z" transform="translate(2576.639 -942.414)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							    </g>
							    <g id="Agrupar_76" data-name="Agrupar 76" transform="translate(-888.544 613.762)" opacity="0.5">
							      <path id="Caminho_603-3" data-name="Caminho 603" d="M177.421,338.373c-2.018,3.144-66.065,98.494-66.065,98.494H124s34.345-1.5,52.4-24.7c2.017-3.144,66.064-98.494,66.064-98.494H229.815S194.853,311.936,177.421,338.373Z" transform="translate(1421.395 -909.199)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							      <path id="Caminho_604-3" data-name="Caminho 604" d="M155.8,330.284c-1.358,2.115-44.446,66.263-44.446,66.263h8.506s23.106-1.01,35.249-16.616c1.357-2.115,44.445-66.263,44.445-66.263H191.05S167.53,312.5,155.8,330.284Z" transform="translate(1530.73 -942.414)" fill={ this.state.menuVectorColor } stroke="#e4e4e4" stroke-width="1" opacity="0.542"/>
							    </g>
							  </g>
							</svg>
						</div>

						<div className="close_menu" onClick={ this.changeMenu.bind(this) }><img src={this.images.close_menu} /></div>
						<div className="menu_list">
							<div className="menu_list__row">
								<div className="menu_list__column menu_list__column--MENSAGENS" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#b0c91f') }>
									<div className="column__header">
										<span>01</span> <h3>Mensagens</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/mensagens" text="01 Mensagens" />
									</ul>
								</div>

								<div className="menu_list__column menu_list__column--QUEMSOMOS" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#F8DB56') }>
									<div className="column__header">
										<span>02</span> <h3>Quem somos</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/quem-somos/perfil" text="2.1 Perfil" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/quem-somos/visao-missao-valores" text="2.2 Visão, missão e valores" />
									</ul>
								</div>

								<div className="menu_list__column menu_list__column--ASSOCIADOS" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#D1DB35') }>
									<div className="column__header">
										<span>03</span> <h3>Associados</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/associados" text="03 Associados" />
									</ul>
								</div>
							</div>
							<div className="menu_list__row">
								<div className="menu_list__column menu_list__column--GOVERNANCA" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#B0C920') }>
									<div className="column__header">
										<span>04</span> <h3>Governança<br />corporativa</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/assembleia-geral" text="4.1 Assembleia geral" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/diretoria" text="4.2 Diretoria" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/conselho-fiscal" text="4.3 Conselho Fiscal" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/conselho-de-etica" text="4.4 Conselho de Ética" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/comite-executivo" text="4.5 Comitê Executivo" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/governanca-corporativa/nossos-foruns" text="4.6 Nossos fóruns" />
									</ul>
								</div>

								<div className="menu_list__column menu_list__column--PESSOAS" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#7FC343') }>
									<div className="column__header">
										<span>05</span> <h3>Pessoas</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/pessoas" text="5.1 Pessoas" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/pessoas/perfil" text="5.2 Perfil" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/pessoas/qualidade-de-vida" text="5.3 Qualidade de vida" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/pessoas/engajamento" text="5.4 Engajamento" />
									</ul>
								</div>

								<div className="menu_list__column menu_list__column--ESTRATEGIA" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#1A3E7E') }>
									<div className="column__header">
										<span>06</span> <h3>Estratégia</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/estrategia/plano-de-acao" text="6.1 Resultados do plano de ação 2018" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/estrategia/curto-prazo" text="6.2 Plano de ação 2019" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/estrategia/longo-prazo" text="6.3 ANBIMA +5" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/estrategia/relacionamentos" text="6.4 Relacionamentos" />
									</ul>
								</div>
							</div>
							<div className="menu_list__row">
								<div className="menu_list__column menu_list__column--NOSSOANO" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#017EB9') }>
									<div className="column__header">
										<span>07</span> <h3>Nosso ano</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/nosso-ano/principais-iniciativas" text="7.1 Iniciativas" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/nosso-ano/eventos" text="7.2 Eventos" />
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/nosso-ano/investimentos" text="7.3 Investimentos" />
									</ul>
								</div>

								<div className="menu_list__column menu_list__column--RELATORIO" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#5DC5D3') }>
									<div className="column__header">
										<span>08</span> <h3>Sobre o relatório</h3>
									</div>
									<ul>
										<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/sobre-o-relatorio" text="08 Sobre o relatório" />
									</ul>
								</div>

								<div className="menu_list__column">
									<div className="column__item column__item--SUMARIO" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#85CCC5') }>
										<div className="column__header">
											<span>09</span> <h3>Sumário GRI</h3>
										</div>
										<ul>
											<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/sumario-gri" text="09 Sumário GRI" />
										</ul>
									</div>

									<div className="column__item column__item--CREDITOS" onMouseEnter={ this.changeMenuVectorColor.bind(null, '#D0DC35') }>
										<div className="column__header">
											<span>10</span> <h3>Créditos</h3>
										</div>
										<ul>
											<ListItem onClick={ this.changeMenuTransition.bind(this) } path="/creditos" text="10 Créditos" />
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>

					<Switch>
						<Route exact path="/" component={ Home } />

						<Route path="/mensagens" component={ Mensagens } />

						<Route path="/quem-somos/perfil" component={ QuemSomosPerfil } />
						<Route path="/quem-somos/visao-missao-valores" component={ QuemSomosVisao } />

						<Route path="/associados" component={ Associados } />

						<Route path="/governanca-corporativa/assembleia-geral" component={ GovernancaAssembleiaGeral } />
						<Route path="/governanca-corporativa/diretoria" component={ GovernancaDiretoria } />
						<Route path="/governanca-corporativa/conselho-fiscal" component={ GovernancaConselhoFiscal } />
						<Route path="/governanca-corporativa/conselho-de-etica" component={ GovernancaConselhoEtica } />
						<Route path="/governanca-corporativa/comite-executivo" component={ GovernancaComiteExecutivo } />
						<Route path="/governanca-corporativa/nossos-foruns" component={ GovernancaNossosForuns } />

						<Route exact path="/pessoas" component={ Pessoas } />
						<Route path="/pessoas/perfil" component={ Perfil } />
						<Route path="/pessoas/qualidade-de-vida" component={ QualidadeVida } />
						<Route path="/pessoas/engajamento" component={ Engajamento } /> 

						<Route path="/estrategia/plano-de-acao" component={ EstrategiaPlanoAcao } />
						<Route path="/estrategia/curto-prazo" component={ EstrategiaCurtoPrazo } />
						<Route path="/estrategia/longo-prazo" component={ EstrategiaLongoPrazo } />
						<Route path="/estrategia/relacionamentos" component={ EstrategiaRelacionamentos } />

						<Route path="/nosso-ano/principais-iniciativas" component={ NossoAnoIniciativas } />
						<Route path="/nosso-ano/eventos" component={ NossoAnoEventos } />
						<Route path="/nosso-ano/investimentos" component={ NossoAnoInvestimentos } />

						<Route path="/sobre-o-relatorio" component={ SobreRelatorio } />
						<Route path="/sumario-gri" component={ SumarioGri } />
						<Route path="/creditos" component={ Creditos } />

						<Route path="*" component={ NotFound }/>
					</Switch>

					<div className={ footerClassItem.join(' ') }>
						<div className={ footerPrevClassItem.join(' ') } onClick={ this.animateTransition }>
							<DelayLink to={this.state.menuPrevLink} delay={1000}>
								<div class="arrow">
									<img src={ this.images.left_arrow_menu } />
									Anterior
								</div>
								<div class="area_name">{this.state.menuPrevText}</div>
	            			</DelayLink>
						</div>

						<div className={ footerNextClassItem.join(' ') } onClick={ this.animateTransition }>
							<DelayLink to={this.state.menuNextLink} delay={1000}>
								<div class="area_name">{this.state.menuNextText}</div>
								<div class="arrow">
									<img src={ this.images.right_arrow_menu } />
									Próximo
								</div>
	            			</DelayLink>
						</div>
					</div>

					<GAnalytics />

				</div>

			</HashRouter>

		);
	}
}